import { api } from './api';

export const LockType = Object.freeze({ Anonymization: 'ANONYMIZATION' });

// Define a service using a base URL and expected endpoints
export const entityLockApi = api.injectEndpoints({
  reducerPath: 'entityLockApi',
  tagTypes: ['EntityLocks'],
  endpoints: (builder) => ({
    getLock: builder.query({
      query: ({ entityId, lockType }) => ({
        url: `public/api/entities/${entityId}/locks/${lockType}`,
        method: 'GET'
      }),
      providesTags: (result, error, { entityId, lockType }) => [
        { type: 'EntityLocks', id: `${entityId}_${lockType}` }
      ]
    }),
    lock: builder.mutation({
      query: ({ entityId, lockType }) => ({
        url: `public/api/entities/${entityId}/locks/${lockType}`,
        method: 'POST'
      }),
      invalidatesTags: (result, error, { entityId, lockType }) => [
        { type: 'EntityLocks', id: `${entityId}_${lockType}` }
      ]
    }),
    unlock: builder.mutation({
      query: ({ entityId, lockType }) => ({
        url: `public/api/entities/${entityId}/locks/${lockType}`,
        method: 'DELETE'
      }),
      invalidatesTags: (result, error, { entityId, lockType }) => [
        { type: 'EntityLocks', id: `${entityId}_${lockType}` }
      ]
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetLockQuery, useLockMutation, useUnlockMutation } = entityLockApi;
